import styles from './CommentReplyButton.module.scss'
import { Record, Static, Function } from 'runtypes'

const CommentReplyButtonProps = Record({
  toggle: Function,
})

type CommentReplyButtonProps = Static<typeof CommentReplyButtonProps>

const CommentReplyButton = ({ toggle }: CommentReplyButtonProps) => {
  return (
    <div
      className={`${styles.CommentReplyButton} w-full flex justify-end cursor-pointer`}
      onClick={toggle}
    >
      <svg
        version="1.1"
        x="0px"
        y="0px"
        width={20}
        className={`${styles.ReplyButton} mr-0.5`}
        viewBox="0 0 487.09 487.09"
      >
        <g>
          <g>
            <path
              d="M26.932,389.625c65.066-50.384,137.016-97.004,222.237-97.004l1.328,0.01c0.869,6.037,0.569,28.731,0.27,36.516
                                c-0.274,7.013,1.823,16.555,7.109,22.054c2.706,2.803,6.043,4.286,9.658,4.286c2.554,0,5.271-0.731,8.063-2.174
                                c28.96-14.955,56.635-34.221,83.386-52.852c25.131-17.493,51.12-35.586,77.973-49.941c4.524-2.418,7.271-6.317,7.738-10.986
                                c0.503-5.018-1.797-10.479-5.87-14.011c-1.056-1.513-2.27-2.765-3.696-3.826c-23.277-17.174-47.489-37.173-70.904-56.522
                                c-27.979-23.118-56.914-47.022-85.102-66.864c-2.661-1.872-5.443-2.818-8.282-2.818c-6.611,0-12.573,5.403-14.041,12.418
                                c-0.629,1.579-1.005,2.993-1.178,4.451c-1.808,16.016-2.681,41.937-2.98,52.509C127.468,176.333,59.743,273.68,6.066,364.15
                                c-0.759,1.279-1.325,2.646-1.706,4.133c-4.07,3.778-5.37,8.739-3.562,13.746c2.326,6.419,9.133,11.085,16.174,11.085
                                C20.543,393.114,23.984,391.906,26.932,389.625z M69.982,321.174c42.632-61.692,99.785-122.028,195.871-126.2
                                c1.239-0.056,2.468-0.249,3.239-0.513c7.089-0.511,14.259-5.337,14.305-14.98c0.036-9.684,0.381-27.675,1.001-39.836
                                c20.307,14.488,41.004,32.41,61.062,49.777c18.28,15.828,37.146,32.161,55.573,45.766c-19.855,11.732-39.369,25.544-58.27,38.92
                                c-19.708,13.944-40.045,28.34-60.743,40.35c-0.325-11.726-1.468-29.117-3.448-38.913c-0.711-3.519-2.417-6.429-4.936-8.444
                                c-2.717-3.188-6.51-5.012-10.988-5.261C200.083,258.36,138.954,277.052,69.982,321.174z"
            />
            <path
              d="M471.242,207.555c-0.097-0.089-0.162-0.188-0.264-0.277c-44.133-37.412-87.723-75.477-133.465-110.928
                                c-10.461-8.107-25.299,6.5-14.706,14.706c45.742,35.452,89.332,73.514,133.465,110.929c0.979,0.828,2.001,1.384,3.036,1.803
                                c0.219,0.267,0.392,0.536,0.65,0.797c8.135,8.179,8.942,15.257,0.649,23.641c-0.665,0.671-1.183,1.376-1.619,2.093
                                c-46.489,32.321-92.577,65.241-140.473,95.476c-11.328,7.149,2.037,23.115,13.224,16.052
                                c48.941-30.895,95.983-64.592,143.509-97.594c2.381-1.65,3.574-3.702,3.955-5.81c12.035-15.538,10.121-33.821-4.545-48.558
                                C473.573,208.792,472.419,208.052,471.242,207.555z"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
      <p className="text-gold mr-0.5 font-bold">Odgovori</p>
    </div>
  )
}

export default CommentReplyButton
